<template>
    <section slot="content" class="gz-public__page gz-public__authorization-page">
        <GZ-Authorization />
    </section>        
</template>

<script>
export default {
    name: 'AuthorizationGuestView'
}
</script>